import axios from "axios";
import { Cookies } from "react-cookie";

const axiosInstance = async (
  url,
  method = "get",
  data,
  customHeaders = {},
  onUploadProgress,
) => {
  const cookies = new Cookies();
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  instance.interceptors.request.use(
    (config) => {
      if (cookies.get("token")) {
        config.headers.Authorization = `Bearer ${cookies.get("token")}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  // Build config; maintain backward compatibility where callers may pass
  // responseType/params/signal inside customHeaders by promoting them to
  // top-level config. The `signal` promotion (F2.2) enables AbortController
  // cancellation; without it, callers passing `signal` via customHeaders had
  // their AbortSignal serialized as a request HEADER instead of axios config,
  // so .abort() never cancelled the in-flight request.
  //
  // `timeout` joins the promotion list in W4-F2.3 (fix batch item 5, Codex M2)
  // and for the same reason: a caller passing it would otherwise send the
  // number as a request HEADER, axios would apply no timeout at all, and a
  // request the server accepts and never answers would hang for the life of
  // the page. THIS CHANGES NO DEFAULT: the instance below still has no
  // timeout, so every caller that does not ask for one behaves exactly as it
  // does today, and today no caller passes this key.
  const { responseType, params, signal, timeout, ...headers } =
    customHeaders || {};

  const config = {
    headers: {
      ...headers,
    },
    ...(responseType ? { responseType } : {}),
    ...(params ? { params } : {}),
    ...(signal ? { signal } : {}),
    ...(timeout ? { timeout } : {}),
    onUploadProgress,
  };

  const methodLower = String(method || "get").toLowerCase();
  if (methodLower === "get" || methodLower === "delete") {
    // For GET/DELETE, axios expects (url, config)
    return await instance[methodLower](url, config);
  }
  // For POST/PUT/PATCH, axios expects (url, data, config)
  return await instance[methodLower](url, data, config);
};

export default axiosInstance;
